import { ArrowUpRight } from "lucide-react";

const TIERS = [
    {
        num: "01",
        name: "Demo Foundation",
        tagline: "For tracks that need shape",
        desc: "Foundational work focused on balance and clarity",
    },
    {
        num: "02",
        name: "Record Finish",
        tagline: "The full finishing process",
        desc: "Full mix and mastering to turn the track into a finished record",
        featured: true,
    },
    {
        num: "03",
        name: "Full Release",
        tagline: "Hands-on collaboration",
        desc: "A mix and mastering that includes direct calls and live revisions",
    },
];

const GALLERY = [
    {
        src: "https://customer-assets.emergentagent.com/job_audio-engineer-denis/artifacts/6o91z6hn_ChatGPT%20Image%2030%20gen%202026%2C%2022_44_18.png",
        filter: "grayscale(1) brightness(1.45) contrast(0.92)",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_audio-engineer-denis/artifacts/detk63zf_ChatGPT%20Image%2030%20gen%202026%2C%2023_02_27.png",
        filter: "grayscale(1) brightness(1.05) contrast(1)",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_audio-engineer-denis/artifacts/w4xoo104_ChatGPT%20Image%2030%20gen%202026%2C%2022_28_24.png",
        filter: "grayscale(1) brightness(1.05) contrast(1)",
    },
];

export const Services = () => {
    return (
        <section
            id="services"
            data-testid="services-section"
            className="px-6 lg:px-12 py-24 lg:py-32 border-t border-black/15"
        >
            <div className="max-w-[1440px] mx-auto">
                <div className="grid grid-cols-12 gap-y-10 lg:gap-x-8 items-end mb-14 lg:mb-20">
                    <div className="col-span-12 lg:col-span-3">
                        <p className="overline" data-testid="services-overline">
                            (01) — Mix &amp; Mastering
                        </p>
                    </div>
                    <div className="col-span-12 lg:col-span-9">
                        <h2
                            data-testid="services-title"
                            className="font-serif-display text-5xl sm:text-6xl lg:text-7xl tracking-[-0.02em] leading-[0.95] text-ink max-w-4xl"
                        >
                            Mix and mastering
                        </h2>
                        <p className="mt-6 font-sans text-base text-quiet max-w-2xl">
                            Every project starts with a short review before any work begins, and includes <span className="text-ink">three rounds of revisions</span>.
                        </p>
                    </div>
                </div>

                <div
                    className="grid grid-cols-1 lg:grid-cols-3 border-t border-l border-black/15"
                    data-testid="services-grid"
                >
                    {TIERS.map((s) => (
                        <article
                            key={s.num}
                            data-testid={`service-card-${s.num}`}
                            className={`group relative p-8 lg:p-12 border-r border-b border-black/15 flex flex-col transition-colors duration-500 ${
                                s.featured
                                    ? "bg-ink text-bone"
                                    : "bg-bone hover:bg-paper"
                            }`}
                        >
                            <h3 className="font-serif-display text-4xl lg:text-5xl leading-[0.95] tracking-[-0.01em]">
                                {s.name}
                            </h3>
                            <p
                                className={`mt-6 font-sans text-base leading-relaxed max-w-prose ${
                                    s.featured ? "text-bone/85" : "text-quiet"
                                }`}
                            >
                                {s.desc}
                            </p>

                            <div className="mt-auto pt-10">
                                <a
                                    href="#contact"
                                    data-testid={`service-cta-${s.num}`}
                                    className={`inline-flex items-center justify-between gap-4 px-5 py-3.5 font-mono text-[11px] tracking-[0.22em] uppercase transition-all ${
                                        s.featured
                                            ? "bg-bone text-ink hover:bg-transparent hover:text-bone hover:ring-1 hover:ring-bone"
                                            : "border border-ink hover:bg-ink hover:text-bone"
                                    }`}
                                >
                                    Start a project
                                    <ArrowUpRight size={16} />
                                </a>
                            </div>
                        </article>
                    ))}
                </div>

                {/* Studio gallery strip */}
                <div
                    className="mt-14 lg:mt-20 grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6"
                    data-testid="services-gallery"
                >
                    {GALLERY.map((g, i) => (
                        <div
                            key={i}
                            className="aspect-[4/3] overflow-hidden border border-black/15 grain bg-ink"
                            data-testid={`services-gallery-${i}`}
                        >
                            <img
                                src={g.src}
                                alt={`Studio shot ${i + 1}`}
                                style={{ filter: g.filter }}
                                className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;
